import { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Cookies from "js-cookie";
import { motion, AnimatePresence } from "framer-motion";
import tokenService from "../../../../utils/tokenService";

const RegisterNew = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const [statusPage, setStatusPage] = useState(1);
  const [statusConfirmIDInviter, setStatusConfirmIDInviter] = useState(false);
  const [provinceSelected, setProvinceSelected] = useState(null);
  const [amphureSelected, setAmphureSelected] = useState(null);
  const [tambonSelected, setTambonSelected] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("");
  const [resendCooldown, setResendCooldown] = useState(0);

  const [idFromURLRegister, setIdFromURLRegister] = useState(null);

  useEffect(() => {
    const pageFromUrl = searchParams.get("statusPage");
    if (pageFromUrl) setStatusPage(Number(pageFromUrl));
    getIdFromUrl();
    getIdFromLocalStorage();
    loadInputDataFromCookies();
  }, [searchParams]);

  const getIdFromUrl = async () => {
    const ID_Invite = searchParams.get("ID");
    const IDLocal = localStorage.getItem("@ID_INVITER");
    const USER_HAVE_INVITER_FROM_URL_BEFORE = localStorage.getItem("@HAVE_INVITER_URL");
    if (IDLocal === null || IDLocal !== ID_Invite) {
      if (ID_Invite !== null && USER_HAVE_INVITER_FROM_URL_BEFORE !== "true") {
        localStorage.setItem("@ID_INVITER", ID_Invite);
      }
    }
  };

  const getIdFromLocalStorage = () => {
    const IDLocal = localStorage.getItem("@ID_INVITER");
    if (IDLocal !== null) {
      setIdFromURLRegister(IDLocal);
      setUpload((prev) => ({ ...prev, inviter_uname: IDLocal }));
    }
  };

  const [upload, setUpload] = useState({
    phone_number: "",
    otp: "",
    check_phoneNumber: "",
    uname: "",
    password: "",
    confirmPassword: "",
    email_address: "",
    firstName: "",
    lastName: "",
    gender: "",
    age: "",
    role: "default",
    inviter_uname: "",
    zipcode: null,
    facebookUrl: "",
    lineId: "",
  });

  const {
    otp, check_phoneNumber, uname, password, confirmPassword,
    gender, email_address, firstName, lastName, age, role,
    inviter_uname, zipcode, facebookUrl, lineId,
  } = upload;

  const inputValue = (name) => (e) => {
    const newValue = { ...upload, [name]: e.target.value };
    setUpload(newValue);
    saveInputDataToCookies(newValue);
    if (name === "password") setPasswordStrength(calculatePasswordStrength(e.target.value));
  };

  const loadInputDataFromCookies = () => {
    const savedData = Cookies.get("registerInputData");
    if (savedData) {
      const parsed = JSON.parse(savedData);
      setUpload((prev) => ({ ...prev, ...parsed }));
      if (parsed.check_phoneNumber) checkPhoneNumber(parsed.check_phoneNumber);
    }
  };

  const saveInputDataToCookies = (data) => {
    const { password, confirmPassword, ...safeData } = data;
    Cookies.set("registerInputData", JSON.stringify(safeData), { expires: 3 / 24 });
  };

  const [textCheckPhoneNumber, setTextCheckPhoneNumber] = useState("กรุณากรอกเบอร์โทรศัพท์ 10 หลัก");

  const checkPhoneNumber = (number) => {
    if (number !== "" && number.length === 10) {
      axios
        .post(`${process.env.REACT_APP_API}/user/checkPhoneNumber`, { checkPhoneNumber: number })
        .then((res) => {
          setTextCheckPhoneNumber(res.data.Status === true ? "เบอร์นี้สมัครสมาชิกแล้ว" : "เบอร์นี้สามารถใช้งานได้");
        })
        .catch(() => {});
    }
    if (number.length !== 10) setTextCheckPhoneNumber("กรุณากรอกเบอร์โทร 10 หลัก");
  };

  const registerConfirmStep = (e) => {
    e.preventDefault();
    if (!statusConfirmPolicy) {
      Swal.fire("", "กรุณายอมรับข้อตกลงการใช้งานเว็บไซต์ก่อนสมัครเป็นสมาชิก", "warning");
    } else if (password !== confirmPassword) {
      Swal.fire("", "รหัสผ่านกับยืนยันรหัสผ่านไม่ตรงกัน", "warning");
    } else if (password.length < 8) {
      Swal.fire("", "รหัสผ่านขั้นต่ำ 8 ตัว", "warning");
    } else {
      axios
        .post(`${process.env.REACT_APP_API}/auth/register`, {
          uname, password, email_address,
          firstName: firstName === "" ? "ไม่ระบุ" : firstName,
          lastName: lastName === "" ? "ตัวตน" : lastName,
          age, role,
          phone_number: check_phoneNumber,
          inviter_uname: inviter_uname === "" ? "Manday" : inviter_uname,
          zipcode, province: provinceSelected, amphure: amphureSelected, tambol: tambonSelected,
        })
        .then(async (res) => {
          await Swal.fire({ icon: "success", title: "สำเร็จ", text: `${res.data.Success}` });
          setStatusPage(statusPage + 1);
          setSearchParams({ statusPage: statusPage + 1 });
        })
        .catch((err) => {
          countFailedReg();
          Swal.fire({ icon: "error", title: "ไม่สำเร็จ", text: `${err.response?.data?.Error || "เกิดข้อผิดพลาด"}` });
        });
    }
  };

  function countFailedReg() {
    axios.post(`${process.env.REACT_APP_ADMIN_API}/event/count-try-reg`, {}).catch(() => {});
  }

  function calculatePasswordStrength(password) {
    let strength = 0;
    if (password.length >= 8) strength++;
    if (password.match(/[a-z]+/)) strength++;
    if (password.match(/[A-Z]+/)) strength++;
    if (password.match(/[0-9]+/)) strength++;
    if (password.match(/[$@#&!]+/)) strength++;
    if (strength <= 2) return "ไม่ปลอดภัย";
    if (strength <= 4) return "ปานกลาง";
    return "ปลอดภัยสูง";
  }

  function validateEmail() {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const allowedDomains = ["@gmail.com", "@hotmail.com", "@yahoo.com", "@outlook.com", "@icloud.com"];
    const domain = email_address.slice(email_address.indexOf("@"));
    if (email_address.length >= 80) {
      Swal.fire("ข้อมูลไม่ถูกต้อง", "Email address ต้องมีตัวอักขระน้อยกว่า 80 ตัวอักษร", "warning");
      return false;
    } else if (!emailRegex.test(email_address)) {
      Swal.fire("ข้อมูลไม่ถูกต้อง", "รูปแบบอีเมลไม่ถูกต้อง", "warning");
      return false;
    } else if (!allowedDomains.includes(domain)) {
      Swal.fire("ข้อมูลไม่ถูกต้อง", "อีเมลที่รองรับ Gmail, Hotmail, Yahoo, และ Outlook", "warning");
      return false;
    }
    return true;
  }

  function checkConfirmStepTwotoStepThree() {
    if (!uname) return Swal.fire("ข้อมูลไม่ครบถ้วน", "กรุณาระบุ ID ของท่าน", "warning");
    if (!password) return Swal.fire("ข้อมูลไม่ครบถ้วน", "กรุณาใส่รหัสผ่าน", "warning");
    if (!confirmPassword) return Swal.fire("ข้อมูลไม่ครบถ้วน", "กรุณายืนยันรหัสผ่าน", "warning");
    if (password !== confirmPassword) return Swal.fire("ข้อมูลไม่ถูกต้อง", "รหัสผ่านไม่ตรงกัน", "warning");
    if (!age) return Swal.fire("ข้อมูลไม่ครบถ้วน", "กรุณาระบุอายุ", "warning");
    if (!validateEmail()) return;
    setStatusPage(statusPage + 1);
    setSearchParams({ statusPage: statusPage + 1 });
  }

  const resendOtp = () => {
    axios
      .post(`${process.env.REACT_APP_API}/auth/resend-otp`, { phone_number: check_phoneNumber })
      .then(() => {
        setUpload((prev) => ({ ...prev, otp: "" }));
        setResendCooldown(60);
        const timer = setInterval(() => {
          setResendCooldown((prev) => {
            if (prev <= 1) { clearInterval(timer); return 0; }
            return prev - 1;
          });
        }, 1000);
        Swal.fire({ icon: "success", title: "ส่ง OTP ใหม่แล้ว", text: "กรุณาตรวจสอบ SMS", timer: 2000, showConfirmButton: false });
      })
      .catch(() => Swal.fire({ icon: "error", title: "ไม่สำเร็จ", text: "ไม่สามารถส่ง OTP ได้ กรุณาลองใหม่" }));
  };

  const setCookies = async (token) => {
    tokenService.setToken(token);
    window.location.replace("/home");
  };

  const otpConfirm = (e) => {
    e.preventDefault();
    setTimeout(() => {
      axios
        .post(`${process.env.REACT_APP_API}/auth/verify-otp`, {
          phone_number: check_phoneNumber,
          otp: otp,
        })
        .then((res) => {
          Swal.fire({ icon: "success", title: "สำเร็จ", text: "กำลังพาคุณไปหน้าหลัก" });
          setCookies(res.data.token);
        })
        .catch((err) => {
          Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาด", text: `${err.response?.data?.Error || "เกิดข้อผิดพลาด"}` });
          setUpload({ ...upload, otp: "" });
        });
    }, 100);
  };

  const crossCheckPhoneNumber = () => {
    if (check_phoneNumber.length !== 10) {
      Swal.fire("รูปแบบเบอร์ไม่ถูกต้อง", "กรุณากรอกให้ครบ 10 หลัก", "error");
    } else if (check_phoneNumber.startsWith("0")) {
      if (textCheckPhoneNumber === "เบอร์นี้สามารถใช้งานได้") {
        setStatusPage(statusPage + 1);
        setSearchParams({ statusPage: statusPage + 1 });
      } else {
        Swal.fire("ไม่สำเร็จ", "เบอร์นี้สมัครสมาชิกแล้ว", "error");
      }
    }
  };

  const [dataInviterUnameFromAPI, setDataInviterUnameFromAPI] = useState([]);

  const inviter_uname_search = (keyword) => {
    axios
      .post(`${process.env.REACT_APP_API}/user/fetch-uname?uname=${keyword}`, { keyword })
      .then((res) => setDataInviterUnameFromAPI(res.data))
      .catch(() => {});
  };

  function handleSelectedInviter(e) {
    const uname = e.target.getAttribute("data-uname");
    setUpload({ ...upload, inviter_uname: uname });
    setDataInviterUnameFromAPI([]);
  }

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]?$/.test(value)) {
      const newOtp = otp.split("");
      newOtp[index] = value;
      const newOtpStr = newOtp.join("");
      setUpload({ ...upload, otp: newOtpStr });

      if (value && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }

      if (newOtpStr.length === 6 && newOtpStr.split("").every((n) => n !== "")) {
        axios
          .post(`${process.env.REACT_APP_API}/auth/verify-otp`, {
            phone_number: check_phoneNumber,
            otp: newOtpStr,
          })
          .then((res) => {
            Swal.fire({ icon: "success", title: "สำเร็จ", text: "กำลังพาคุณไปหน้าหลัก" });
            setCookies(res.data.token);
          })
          .catch((err) => {
            Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาด", text: `${err.response?.data?.Error || "เกิดข้อผิดพลาด"}` });
            setUpload({ ...upload, otp: "" });
          });
      }
    }
  };

  const [addressData, setAddressData] = useState([]);
  const provinceArr = [];
  const [provinceData, setProvinceData] = useState([]);
  const DistrictsArr = [];
  const [districtsData, setdistrictsData] = useState([]);
  const TambonArr = [];
  const [TambonData, setTambonData] = useState([]);

  useEffect(() => {
    if (addressData !== "") {
      addressData.map((data) => {
        const provinceCheck = data.amphure.province.name_th;
        const DistrictCheck = data.amphure.name_th;
        const TambonCheck = data.name_th;
        if (provinceArr.indexOf(provinceCheck) === -1) {
          setProvinceSelected(data.amphure.province.name_th);
          provinceArr.push(data.amphure.province.name_th);
        }
        if (DistrictsArr.indexOf(DistrictCheck) === -1) {
          setAmphureSelected(data.amphure.name_th);
          DistrictsArr.push(data.amphure.name_th);
        }
        if (TambonArr.indexOf(TambonCheck) === -1) TambonArr.push(data.name_th);
      });
    }
    setProvinceData(provinceArr);
    setdistrictsData(DistrictsArr);
    setTambonData(TambonArr);
  }, [addressData]);

  const [statusConfirmPolicy, setStatusConfirmPolicy] = useState(false);
  const [popupPolicy, setPopupPolicy] = useState(false);

  function handlePolicyButton() { setStatusConfirmPolicy(!statusConfirmPolicy); }
  function handlePopupPolicy() { window.scrollTo({ top: 0, behavior: "smooth" }); setPopupPolicy(true); }
  function handleConfirmPolicy() { setPopupPolicy(false); setStatusConfirmPolicy(true); }

  const policyText = `ข้อตกลงการใช้งานเว็บไซต์ Postperty.com
1. ขอบเขตของข้อตกลง ข้อตกลงนี้กำหนดเงื่อนไขการใช้บริการของเว็บไซต์ Postperty.com ("เว็บไซต์") ซึ่งเป็นแพลตฟอร์มสำหรับการซื้อ-ขายและโฆษณาอสังหาริมทรัพย์ ผู้ใช้บริการ ("ผู้ใช้") ต้องอ่านและยอมรับเงื่อนไขก่อนใช้งานเว็บไซต์

2. การสมัครสมาชิกและการใช้งาน
2.1 ผู้ใช้ต้องให้ข้อมูลที่ถูกต้องและเป็นจริงเมื่อสมัครสมาชิก
2.2 ผู้ใช้เป็นผู้รับผิดชอบต่อบัญชีของตนเอง และต้องรักษาข้อมูลเข้าสู่ระบบเป็นความลับ
2.3 ผู้ใช้ตกลงที่จะไม่ใช้เว็บไซต์เพื่อกิจกรรมที่ผิดกฎหมาย หรือขัดต่อศีลธรรมอันดี
2.4 ผู้ใช้ 1คน มีสิทธิ์สมัครได้แค่ 1 ID เท่านั้น

3. ขอบเขตความรับผิดชอบของเว็บไซต์
3.1 เว็บไซต์ทำหน้าที่เป็นสื่อกลางระหว่างผู้ซื้อและผู้ขายอสังหาริมทรัพย์เท่านั้น
3.2 เว็บไซต์ไม่รับผิดชอบต่อความเสียหายใด ๆ ที่เกิดขึ้นจากการซื้อ-ขาย
3.3 เว็บไซต์มีสิทธิ์แก้ไข ปรับปรุง หรือยุติการให้บริการบางส่วนหรือทั้งหมดได้โดยไม่ต้องแจ้งล่วงหน้า

4. ข้อกำหนดเกี่ยวกับการลงประกาศ
4.1 ผู้ใช้ต้องรับผิดชอบต่อข้อมูลที่โพสต์ลงในเว็บไซต์ และต้องเป็นข้อมูลที่ถูกต้อง
4.2 ห้ามลงประกาศที่ละเมิดกฎหมาย ละเมิดลิขสิทธิ์ หรือมีเนื้อหาที่ไม่เหมาะสม

5. ค่าธรรมเนียมและการชำระเงิน
5.1 การใช้บริการบางประเภทบนเว็บไซต์อาจมีค่าธรรมเนียม
5.2 ค่าธรรมเนียมที่ชำระไปแล้วจะไม่สามารถขอคืนได้ ยกเว้นในกรณีที่เว็บไซต์เป็นฝ่ายยกเลิกบริการเอง
5.3 การจ่ายค่าตอบแทนในรูปแบบค่าคอมมิชชั่น จะจ่ายให้แก่สมาชิกที่ยืนยันตัวตนแล้วเท่านั้น

6. การยุติการใช้งานบัญชี
6.1 เว็บไซต์มีสิทธิ์ระงับหรือยกเลิกบัญชีของผู้ใช้ หากพบว่ามีการละเมิดเงื่อนไขการให้บริการ
6.2 ผู้ใช้สามารถยกเลิกบัญชีของตนเองได้โดยติดต่อฝ่ายบริการลูกค้า Line OA : @postperty

7. กฎหมายที่ใช้บังคับ
ข้อตกลงนี้อยู่ภายใต้กฎหมายของประเทศไทย`;

  // ── Shared input style
  const inputCls = "w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:border-blue-400 focus:bg-white transition-colors";
  const labelCls = "block text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1.5";

  // ── Step indicator
  const StepDots = () => (
    <div className="flex items-center justify-center gap-2 mb-7">
      {[1, 2, 3].map((s) => (
        <div
          key={s}
          className={`h-1.5 rounded-full transition-all duration-300 ${
            s === statusPage ? "w-6 bg-blue-600" : s < statusPage ? "w-1.5 bg-blue-300" : "w-1.5 bg-gray-200"
          }`}
        />
      ))}
    </div>
  );

  const pageVariants = {
    initial: { opacity: 0, y: 12 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.35, ease: "easeOut" },
  };

  return (
    <>
    {/* navbar บนสุดมาจาก LayoutWrapper ใน App.js อยู่แล้ว (เฉพาะจอกว้างกว่า 822px)
        เดิมหน้านี้เรนเดอร์เองซ้ำอีกชั้น จอมือถือเลยได้ทั้ง navbar บนและแถบล่างพร้อมกัน */}
    <main className="min-h-screen bg-white flex flex-col lg:flex-row font-['Prompt'] pt-[72px] max-[821px]:pt-0">

      {/* ── Left Panel (desktop only) ── */}
      <div className="hidden lg:flex lg:w-[45%] bg-black flex-col justify-between p-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img src="/hero1.png" alt="" className="w-full h-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-br from-black via-black/80 to-black/60" />

        <div />

        {/* Middle content */}
        <div className="relative z-10">
          <h2 className="text-5xl font-black text-white tracking-tighter leading-[1.1] mb-6">
            เริ่มต้น<br /><span className="text-[#34bfd9]">ซื้อขายอสังหาฯ</span><br />วันนี้
          </h2>
          <p className="text-white/60 font-medium text-base leading-relaxed mb-8">
            สมัครสมาชิกฟรี เพื่อเข้าถึงทรัพย์หลายพันรายการบนแผนที่ และรับค่าคอมจากระบบ Affiliate
          </p>
          <div className="space-y-3">
            {[
              "ดูทรัพย์บนแผนที่ได้ทันที",
              "ลงประกาศขายฟรี ไม่มีค่าใช้จ่าย",
              "รับค่าคอมฯ สูงสุด 33%",
            ].map((t) => (
              <div key={t} className="flex items-center gap-3">
                <div className="w-5 h-5 rounded-full bg-[#34bfd9] flex items-center justify-center flex-shrink-0">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <span className="text-white/80 font-medium text-sm">{t}</span>
              </div>
            ))}
          </div>
        </div>

        <p className="relative z-10 text-white/20 text-xs font-bold tracking-widest uppercase">© 2026 POSTPERTY CO., LTD.</p>
      </div>

      {/* ── Right Panel (form) ── */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 bg-gray-50 lg:bg-white">

      {/* ── STEP 1: เบอร์โทร ── */}
      {statusPage === 1 && (
        <motion.div {...pageVariants} className="w-full max-w-sm">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 lg:shadow-none lg:border-0 lg:p-0">

            <StepDots />
            <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">ขั้นตอนที่ 1 / 3</p>
            <h1 className="text-xl font-bold text-gray-900 mb-6">สมัครสมาชิก</h1>

            <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); crossCheckPhoneNumber(); }}>
              <div>
                <label className={labelCls}>เบอร์โทรศัพท์</label>
                <input
                  value={check_phoneNumber}
                  type="tel"
                  placeholder="0XX-XXX-XXXX"
                  onChange={(e) => {
                    inputValue("check_phoneNumber")(e);
                    checkPhoneNumber(e.target.value);
                  }}
                  className={inputCls}
                />
                {check_phoneNumber.length > 0 && (
                  <p
                    className="text-xs mt-1.5 font-medium"
                    style={{
                      color:
                        textCheckPhoneNumber === "เบอร์นี้สามารถใช้งานได้"
                          ? "#16a34a"
                          : textCheckPhoneNumber === "เบอร์นี้สมัครสมาชิกแล้ว"
                          ? "#ef4444"
                          : "#ca8a04",
                    }}
                  >
                    {textCheckPhoneNumber}
                  </p>
                )}
              </div>

              <button
                type="submit"
                className="w-full py-3 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors mt-2"
              >
                ถัดไป
              </button>
            </form>

            <p className="text-xs text-gray-400 text-center mt-5">
              มีบัญชีแล้ว?{" "}
              <Link to="/login" className="text-blue-600 font-medium hover:underline">เข้าสู่ระบบ</Link>
            </p>
          </div>
        </motion.div>
      )}

      {/* ── STEP 2: ข้อมูลผู้ใช้ ── */}
      {statusPage === 2 && (
        <motion.div {...pageVariants} className="w-full max-w-lg">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 lg:shadow-none lg:border-0 lg:p-0">

            <StepDots />

            <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">ขั้นตอนที่ 2 / 3</p>
            <h1 className="text-xl font-bold text-gray-900 mb-6">ระบุข้อมูล</h1>

            <form onSubmit={registerConfirmStep} className="space-y-4">

              {/* ID */}
              <div>
                <label htmlFor="register-uname" className={labelCls}>ID สมาชิก</label>
                <input
                  id="register-uname"
                  name="username"
                  type="text"
                  autoComplete="username"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck={false}
                  placeholder="ระบุ ID ที่ต้องการ"
                  onChange={inputValue("uname")}
                  value={uname}
                  className={inputCls}
                />
              </div>

              {/* Password */}
              <div>
                <label htmlFor="register-password" className={labelCls}>รหัสผ่าน</label>
                <div className="relative">
                  <input
                    id="register-password"
                    name="new-password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="new-password"
                    placeholder="ขั้นต่ำ 8 ตัวอักษร"
                    onChange={inputValue("password")}
                    value={password}
                    className={`${inputCls} pr-12`}
                  />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3.5 top-1/2 -translate-y-1/2">
                    <img
                      src={showPassword ? "https://cdn-icons-png.flaticon.com/512/2767/2767194.png" : "https://cdn-icons-png.flaticon.com/512/2767/2767146.png"}
                      alt="toggle"
                      className="w-5 h-5 opacity-40 hover:opacity-70 transition-opacity"
                    />
                  </button>
                </div>
                {password.length > 0 && (
                  <div className="flex items-center gap-2 mt-1.5">
                    <div className="flex gap-1 flex-1">
                      {["ไม่ปลอดภัย", "ปานกลาง", "ปลอดภัยสูง"].map((level, i) => (
                        <div key={i} className={`h-1 flex-1 rounded-full transition-colors ${
                          passwordStrength === "ปลอดภัยสูง" ? "bg-emerald-500"
                          : passwordStrength === "ปานกลาง" && i <= 1 ? "bg-amber-400"
                          : passwordStrength === "ไม่ปลอดภัย" && i === 0 ? "bg-red-400"
                          : "bg-gray-200"
                        }`} />
                      ))}
                    </div>
                    <span className={`text-xs font-medium flex-shrink-0 ${
                      passwordStrength === "ปลอดภัยสูง" ? "text-emerald-600"
                      : passwordStrength === "ปานกลาง" ? "text-amber-600"
                      : "text-red-500"
                    }`}>
                      {passwordStrength}
                    </span>
                  </div>
                )}
              </div>

              {/* Confirm Password */}
              <div>
                <label htmlFor="register-confirm-password" className={labelCls}>ยืนยันรหัสผ่าน</label>
                <div className="relative">
                  <input
                    id="register-confirm-password"
                    name="confirm-new-password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="new-password"
                    placeholder="กรุณายืนยันรหัสผ่าน"
                    onChange={inputValue("confirmPassword")}
                    value={confirmPassword}
                    className={`${inputCls} pr-12 ${confirmPassword.length > 0 && password !== confirmPassword ? "border-red-300 focus:border-red-400" : ""}`}
                  />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3.5 top-1/2 -translate-y-1/2">
                    <img
                      src={showPassword ? "https://cdn-icons-png.flaticon.com/512/2767/2767194.png" : "https://cdn-icons-png.flaticon.com/512/2767/2767146.png"}
                      alt="toggle"
                      className="w-5 h-5 opacity-40 hover:opacity-70 transition-opacity"
                    />
                  </button>
                </div>
                {confirmPassword.length > 0 && password !== confirmPassword && (
                  <p className="text-xs text-red-500 mt-1.5 font-medium">รหัสผ่านไม่ตรงกัน</p>
                )}
              </div>

              {/* Email */}
              <div>
                <label className={labelCls}>อีเมล</label>
                <input
                  type="email"
                  placeholder="example@gmail.com"
                  onChange={inputValue("email_address")}
                  value={email_address}
                  className={inputCls}
                />
              </div>

              {/* Age */}
              <div>
                <label className={labelCls}>อายุ</label>
                <input
                  type="number"
                  placeholder="อายุ (ปี)"
                  onChange={inputValue("age")}
                  value={age}
                  className={inputCls}
                />
              </div>

              {/* Inviter */}
              <div>
                <label className={labelCls}>ID ผู้แนะนำ <span className="normal-case text-gray-400 font-normal">(ถ้ามี)</span></label>
                <input
                  type="text"
                  placeholder={idFromURLRegister || "ระบุ ID ผู้แนะนำ"}
                  defaultValue={idFromURLRegister}
                  value={inviter_uname}
                  onChange={(e) => {
                    inputValue("inviter_uname")(e);
                    inviter_uname_search(e.target.value);
                  }}
                  className={inputCls}
                />
                {dataInviterUnameFromAPI.length > 0 && (
                  <div className="mt-1 bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
                    {dataInviterUnameFromAPI.map((user, idx) => (
                      <div
                        key={idx}
                        className="px-4 py-3 text-sm text-gray-700 cursor-pointer hover:bg-gray-50 border-b border-gray-100 last:border-0 transition-colors"
                        data-uname={user.uname}
                        onClick={handleSelectedInviter}
                      >
                        {user.uname}
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Policy */}
              <div className="flex items-start gap-3 pt-1">
                <button
                  type="button"
                  onClick={handlePolicyButton}
                  className={`w-5 h-5 rounded flex-shrink-0 mt-0.5 border-2 flex items-center justify-center transition-colors ${
                    statusConfirmPolicy ? "bg-blue-600 border-blue-600" : "border-gray-300 bg-white"
                  }`}
                >
                  {statusConfirmPolicy && (
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                </button>
                <p className="text-xs text-gray-500 leading-relaxed">
                  ฉันยอมรับ{" "}
                  <span
                    className="text-blue-600 font-medium cursor-pointer hover:underline"
                    onClick={handlePopupPolicy}
                  >
                    ข้อตกลงและเงื่อนไขการใช้เว็บไซต์
                  </span>
                </p>
              </div>

              <button
                type="submit"
                className={`w-full py-3 text-sm font-semibold rounded-xl transition-colors ${
                  statusConfirmPolicy
                    ? "bg-blue-600 text-white hover:bg-blue-700"
                    : "bg-gray-100 text-gray-400 cursor-not-allowed"
                }`}
              >
                สมัครสมาชิกทันที
              </button>
            </form>
          </div>
        </motion.div>
      )}

      {/* ── STEP 3: OTP ── */}
      {statusPage === 3 && (
        <motion.div {...pageVariants} className="w-full max-w-sm">
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 lg:shadow-none lg:border-0 lg:p-0">

            <StepDots />

            {/* Icon */}
            <div className="flex justify-center mb-5">
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center border border-blue-100">
                <img src="https://cdn-icons-png.flaticon.com/512/16449/16449658.png" alt="otp" className="w-9 h-9" />
              </div>
            </div>

            <p className="text-xs text-gray-400 uppercase tracking-wider mb-1 text-center">ขั้นตอนสุดท้าย</p>
            <h1 className="text-xl font-bold text-gray-900 text-center mb-2">ยืนยัน OTP</h1>
            <p className="text-sm text-gray-500 text-center mb-6">
              กรอกรหัส 6 หลักที่ส่งไปยัง<br />
              <span className="font-semibold text-gray-700">{check_phoneNumber}</span>
            </p>

            <form onSubmit={otpConfirm} className="space-y-5">
              {/* OTP boxes */}
              <div className="flex justify-center gap-2">
                {[...Array(6)].map((_, index) => (
                  <input
                    key={index}
                    id={`otp-input-${index}`}
                    type="text"
                    inputMode="numeric"
                    maxLength="1"
                    value={otp[index] || ""}
                    onChange={(e) => handleOtpChange(e, index)}
                    className="w-11 h-12 text-center text-lg font-bold bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:border-blue-400 focus:bg-white transition-colors text-gray-800"
                  />
                ))}
              </div>

              <button
                type="submit"
                className="w-full py-3 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors"
              >
                ยืนยัน OTP
              </button>

              <div className="text-center pt-1">
                {resendCooldown > 0 ? (
                  <p className="text-xs text-gray-400">ส่ง OTP ใหม่ได้ในอีก {resendCooldown} วินาที</p>
                ) : (
                  <button
                    type="button"
                    onClick={resendOtp}
                    className="text-xs text-blue-600 font-medium hover:underline"
                  >
                    ไม่ได้รับ OTP? ส่งใหม่อีกครั้ง
                  </button>
                )}
              </div>
            </form>
          </div>
        </motion.div>
      )}

      </div>{/* end right panel */}
    </main>

    {/* ── Policy Modal ── */}

      {popupPolicy && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-end md:items-center z-50 p-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden border border-gray-100"
          >
            <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between flex-shrink-0">
              <h2 className="text-base font-bold text-gray-900">ข้อตกลงและเงื่อนไขการใช้เว็บไซต์</h2>
              <button onClick={() => setPopupPolicy(false)} className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="px-6 py-4 overflow-y-auto flex-1">
              <p className="text-sm text-gray-600 leading-relaxed whitespace-pre-wrap">{policyText}</p>
            </div>
            <div className="px-6 py-4 border-t border-gray-100 flex-shrink-0">
              <button
                onClick={handleConfirmPolicy}
                className="w-full py-3 bg-blue-600 text-white text-sm font-semibold rounded-xl hover:bg-blue-700 transition-colors"
              >
                ยอมรับข้อตกลง
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </>
  );
};

export default RegisterNew;
